import { render, staticRenderFns } from "./Livevideo.vue?vue&type=template&id=2650e35e&"
import script from "./Livevideo.vue?vue&type=script&lang=js&"
export * from "./Livevideo.vue?vue&type=script&lang=js&"
import style0 from "./Livevideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports